/* global dom */
const talkBoxes = document.querySelectorAll('.c-speaker__talk')
dom.forEach(talkBoxes, function (talkBox) {
  const talkOpener = talkBox.querySelector('.c-speaker__talk-info')
  talkOpener.addEventListener('click', function() {
    dom.toggleClass(talkBox, 'js-open')
  })
})
